
export default function generateButton (buttonData) {
    const buttonDefaults = {
        title: null,
        style: 'default', // default, border
        disabled: false,
        light: false,
        fullwidth: false,
        tag: 'button',
        link: null,
        target: null,
        icon: null,
        class: null,
    };

    const button = { ...buttonDefaults, ...buttonData };
    const tag = button.link ? 'a' : 'button';

    return `
        <${tag} 
            class="button button--${button.style}${button.disabled ? ' disabled' : ''}${button.light ? ' light' : ''}${button.fullwidth ? ' button--fullwidth' : ''}${button.class ? ` ${button.class}` : ''}" 
            ${button.disabled ? ' tabIndex="-1"' : ''}
            ${button.link ? `href="${button.link}"` : ''}
            ${button.target ? `target="${button.target}"` : ''}
        >
        <div class="button__content">${button.title}</div>
    </${tag}>
    `;
}
